define(['text!./templates/basler-info-button.html'],
    (templateStr) => {

        return ['ModalService', 'TextRetrievalService',
            function (ModalService, TextRetrievalService) { //NOSONAR
                return {
                    restrict: 'E',
                    template: templateStr,
                    scope: {
                        /** Model (value) to select. */
                        textKey: '@',
                    },
                    link: function ($scope) { // NOSONAR

                        $scope.helpText = undefined; //just a placeholder

                        // Get the help text from the cache or from the Magnolia CMS
                        TextRetrievalService.getInfoText($scope.textKey).then((infoText) => {
                            $scope.helpText = infoText;
                            $scope.$applyAsync(); //to fix issue "$apply already in progress" http://stackoverflow.com/questions/18626039/apply-already-in-progress-error
                        }).catch(() => {}); // prevent log an error message if an info text has not been loaded

                        // Display the info text
                        $scope.displayInfo = function () {
                            ModalService.showSimpleDialog(`
                                <div class="infotext">
                                    <div
                                        class="form-close"
                                        ng-click="$dismiss()"
                                        ng-include="'/qnb/styles/images/common/i_close.svg'"
                                    ></div>
                                    ${$scope.helpText}
                                </div>
                            `);
                        };
                    },
                };
            },
        ];
    }
);



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/BaslerInfoButton.js